const ProjectTaskTargets = {
  toRadioList(items) {
    return items.map((item) => ({value: item.id, label: item.name}));
  },
};

export { ProjectTaskTargets };